__turbopack_context__.v({
  "autogrid": "PointList-module-scss-module__7cM6mG__autogrid",
  "pointlistwrapper": "PointList-module-scss-module__7cM6mG__pointlistwrapper",
  "top": "PointList-module-scss-module__7cM6mG__top",
});
